import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { MfaEnrollmentStartResponse, MfaTotpSetupResponse, MfaEnrollmentMethodResponse, MfaEmailSendResponse } from '../models/mfa';

@Injectable()
export class MfaEnrollmentService {

	constructor(private _http: HttpClient) {}

	startEnrollment(): Observable<MfaEnrollmentStartResponse> {
		return this._http.post<MfaEnrollmentStartResponse>(`${environment.apiUrl}/v2/MfaEnrollment/Start`, {});
	}

	setupTotp(): Observable<MfaTotpSetupResponse> {
		return this._http.post<MfaTotpSetupResponse>(`${environment.apiUrl}/v2/MfaEnrollment/Totp/Setup`, {});
	}

	confirmTotp(code: string): Observable<MfaEnrollmentMethodResponse> {
		return this._http.post<MfaEnrollmentMethodResponse>(`${environment.apiUrl}/v2/MfaEnrollment/Totp/Confirm`, { code });
	}

	sendEmailVerification(email: string): Observable<MfaEmailSendResponse> {
		return this._http.post<MfaEmailSendResponse>(`${environment.apiUrl}/v2/MfaEnrollment/Email/Send`, { email });
	}

	confirmEmail(code: string, email: string): Observable<MfaEnrollmentMethodResponse> {
		return this._http.post<MfaEnrollmentMethodResponse>(`${environment.apiUrl}/v2/MfaEnrollment/Email/Confirm`, { code, email });
	}

	skipEnrollment(): Observable<void> {
		return this._http.post<void>(`${environment.apiUrl}/v2/MfaEnrollment/Skip`, {});
	}
}
